import { selector } from 'recoil'
import sessionStorage from './sessionStorage'

export const isEssModularUserCheck = selector({
  key: 'IsEssModularUser',
  get: ({ get }) => get(sessionStorage)?.user?.email?.endsWith('@essmodular.com') ?? false,
})
